import React, { useState, useEffect, useContext } from "react";

import "./start.css"
import logo from "../rsc/unknown-identity.png"
import { Link } from 'react-router-dom';
import { Context } from '../context';

const defaultUsername = "Anonymous";

const StartPage = () => {

  const [identity, setIdentity] = useState(defaultUsername);
  const { state, dispatch } = useContext(Context);


  useEffect(() => {
    // if local storage can find the user information, try login
    const user = JSON.parse(localStorage.getItem("loggedInUser"));

    dispatch({
      type: "LOGIN",
      payload: {
        user: user,
        token: user ? user.token : ""
      }
    });
    
  }, []);

  useEffect(() => {

    if (state.auth) {
      setIdentity(state.user.username);
    } else {
      setIdentity(defaultUsername);
    }
  }, [state.auth]);

  const showButton = (auth) => {
    if (auth)
      return <button className="logout-button" onClick={() => {
        localStorage.removeItem("loggedInUser");
        dispatch({
          type: "LOGOUT",
        });
      }}>
        LOGOUT
      </button>;
    else
      return <Link to="/login">
        <button className="login-button">
          LOGIN
        </button>
      </Link>;
  }


  return (
    <div className="start-page">
      <header className="start-title">Guess who am I?</header>
      <p>note: third-party cookie needs to be enabled for normal functioning of this web app</p>
      <img className="start-logo" src={logo} alt="logo" />
      <br></br>
      <div className="button-div">
        <Link to="/gameplay">
          <button className="start-button">
            Start as {identity}
          </button>
        </Link>
        {showButton(state.auth)}

      </div>
    </div>
  );
}

export default StartPage;